import { useEffect, useRef } from 'react';

/**
 * Runs `callback` once, when the component goes away.
 *
 * The latest `callback` is the one called: it is held in a ref, so the effect
 * itself has no dependency to re-run on - a cleanup that depended on its
 * callback would fire at every render instead of at the end.
 */
export function useUnmount(callback: () => void): void {
  const latest = useRef(callback);
  latest.current = callback;
  useEffect(() => () => latest.current(), []);
}
